import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import { useAuthed } from '../hooks/useAuthed';
import { gymApi } from '../api/gymApi';
import type { SessionSummary } from '../../../shared/types';

const fmtDate = (secs: number) =>
  new Date(secs * 1000).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });

export default function HistoryPage() {
  const authed = useAuthed();
  const navigate = useNavigate();
  const [sessions, setSessions] = useState<SessionSummary[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    gymApi.listWorkouts(authed)
      .then(s => { if (!cancelled) setSessions(s); })
      .catch(err => { if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load history'); });
    return () => { cancelled = true; };
  }, [authed]);

  return (
    <>
      <SiteHeader back={{ label: 'Home', to: '/' }} />
      <main className="page page--narrow">
        <h1>History</h1>
        {error && <p className="error">{error}</p>}
        {!sessions && !error && <p className="muted">Loading…</p>}
        {sessions?.length === 0 && (
          <p className="muted">No completed workouts yet. Finish one and it'll show up here.</p>
        )}

        <ul className="plain-list">
          {sessions?.map(s => (
            <li key={s.sessionId}>
              <button
                type="button"
                className="history-row"
                onClick={() => navigate(`/history/${s.sessionId}`)}
              >
                <span className="history-row-body">
                  <span className="history-row-title">{s.dayLabel}</span>
                  <span className="muted">
                    {s.completedAt ? fmtDate(s.completedAt) : fmtDate(s.startedAt)}
                    {' · '}{s.setCount} sets
                    {s.totalVolume > 0 && ` · ${Math.round(s.totalVolume).toLocaleString()} volume`}
                  </span>
                </span>
                <span className="exercise-row-chevron" aria-hidden="true">›</span>
              </button>
            </li>
          ))}
        </ul>
      </main>
    </>
  );
}
